// extracted by mini-css-extract-plugin
module.exports = {"drawer":"styles_drawer__29Wah","bottom":"styles_bottom__2mDA7","top":"styles_top__3C9Fu","left":"styles_left__3RO4m","right":"styles_right__2dsNn"};